import DetailQuizBackOffice from './detail';

export default DetailQuizBackOffice;
